import styled from 'styled-components';

export const DashboardViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const DashboardViewHeader = styled.div`
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  border-bottom: 1px solid hsl(var(--border));
`;

export const DashboardViewTitle = styled.h1`
  font-size: 20px;
  font-weight: 500;
  color: hsl(var(--foreground));
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DashboardViewActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const DashboardViewContent = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  width: 100%;
`;
